// extracted by mini-css-extract-plugin
module.exports = {"layout":"layout___31nQD","main":"main___2FQdf","anchor":"anchor___1e3yb","title":"title___2WQby","link":"link___1D4VQ"};